import React from 'react';

export const Play: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.1634 11.5104C17.9625 11.9717 17.9625 13.125 17.1634 13.5863L9.5605 17.9759C8.76148 18.4372 7.76269 17.8606 7.76269 16.9379L7.7627 8.15882C7.7627 7.23619 8.76148 6.65954 9.5605 7.12086L17.1634 11.5104Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Pause: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 8.77832L9.5 16.4136"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="transparent"
      />
      <path
        d="M14.5 8.77832L14.5 16.4136"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="transparent"
      />
    </svg>
  );
};

export const Unmute: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.57603 14.9185C6.57603 14.9185 6.57598 14.9184 6.57591 14.9184H5.22698C4.48192 14.9184 3.87793 14.3144 3.87793 13.5694V10.0985C3.87793 9.28298 4.53906 8.62185 5.3546 8.62185H6.10305C6.41083 8.62185 6.71091 8.52568 6.96135 8.34679L10.5376 5.79231C11.515 5.09419 12.8726 5.79284 12.8726 6.99392V16.5467C12.8726 17.7478 11.515 18.4464 10.5376 17.7483L6.57608 14.9186C6.57605 14.9186 6.57603 14.9186 6.57603 14.9185Z"
        fill="currentColor"
      />
      <path
        d="M15.124 9.04932C15.8618 9.48643 16.3735 10.441 16.3735 11.5483C16.3735 12.6556 15.8618 13.6102 15.124 14.0473"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.623 6.55029C19.0986 7.42452 20.122 9.33372 20.122 11.5483C20.122 13.7628 19.0986 15.672 17.623 16.5462"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Mute: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52451 17.5964L7.384 17.7478C7.10215 18.0513 7.11973 18.5258 7.42326 18.8077C7.72679 19.0895 8.20134 19.072 8.48319 18.7684L10.5474 16.5454L12.3785 17.8533C13.3558 18.5514 14.7134 17.8528 14.7134 16.6517V12.059L18.0816 8.43173C18.3634 8.12819 18.3458 7.65365 18.0423 7.3718C17.7536 7.10372 17.3102 7.10652 17.025 7.3686L7.56718 17.554C7.5534 17.5688 7.53917 17.583 7.52451 17.5964ZM14.7134 7.6536V7.0989C14.7134 5.89782 13.3558 5.19917 12.3785 5.89729L8.80217 8.45177C8.55173 8.63066 8.25165 8.72683 7.94388 8.72683H7.19542C6.37988 8.72683 5.71875 9.38796 5.71875 10.2035V13.6744C5.71875 14.4194 6.32274 15.0234 7.0678 15.0234H7.87004L14.7134 7.6536Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CaptionsOn: React.FC = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 3.72852C4.25736 3.72852 3.25 4.73587 3.25 5.97852V18.9785C3.25 20.2212 4.25736 21.2285 5.5 21.2285H18.5C19.7426 21.2285 20.75 20.2212 20.75 18.9785V5.97852C20.75 4.73587 19.7426 3.72852 18.5 3.72852H5.5ZM12.5 10.2285C12.5 9.67623 12.9477 9.22852 13.5 9.22852H16.5C17.0523 9.22852 17.5 9.67623 17.5 10.2285C17.5 10.7808 17.0523 11.2285 16.5 11.2285H14.5V13.7285H16.5C17.0523 13.7285 17.5 14.1762 17.5 14.7285C17.5 15.2808 17.0523 15.7285 16.5 15.7285H13.5C12.9477 15.7285 12.5 15.2808 12.5 14.7285V10.2285ZM7.5 9.22852C6.94772 9.22852 6.5 9.67623 6.5 10.2285V14.7285C6.5 15.2808 6.94772 15.7285 7.5 15.7285H10.5C11.0523 15.7285 11.5 15.2808 11.5 14.7285C11.5 14.1762 11.0523 13.7285 10.5 13.7285H8.5V11.2285H10.5C11.0523 11.2285 11.5 10.7808 11.5 10.2285C11.5 9.67623 11.0523 9.22852 10.5 9.22852H7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CaptionsOff: React.FC = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="4.45508"
        width="16"
        height="16"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M16.5 10.2051H13.5V14.7051H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M10.5 10.2051H7.5V14.7051H10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </svg>
  );
};
